import { render, staticRenderFns } from "./SirketDetay.vue?vue&type=template&id=34b481e0&"
import script from "./SirketDetay.vue?vue&type=script&lang=js&"
export * from "./SirketDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports